import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import Pagination from '../../../../components/pagination/Pagination.jsx';
import Segmented from "../../../../components/segmented/Segmented.jsx";
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton.jsx';
import columns from '../../../../columns/depositRequest.jsx';
import Eye from "../../../../assets/Eye.jsx";
import ModalComponent from "../../../../components/modals/ModalComponent.jsx";
import { DeletePendingDepositRequest, GetAllDepositRequestApi } from '../../../../api/request/wallet/cashdeposit.js';
import { formatDate } from '../../../../utils/utils.js';
import { useResponsive } from '../../../../hooks/useResponsive.js';
import Delete from '../../../../assets/Delete.jsx';
import ConfirmationModal from '../../../../components/modals/ConfirmationModal.jsx';
import toast from 'react-hot-toast';

const DepositRequest = ({ isRefresh, setIsRefresh }) => {
    const { isMobile } = useResponsive()
    const { userDetails } = useSelector(state => state.user);
    const [filter, setFilter] = useState('Approved');
    const [data, setData] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sorter, setSorter] = useState({ SortBy: 'requestDate', SortOrder: '' });
    const [depositdetails, setDepositdetails] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDocumentOpen, setIsDocumentOpen] = useState(false);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);

    const getFilteredColumns = (statusFilter) => {
        if (statusFilter === 'Pending') {
            return columns.filter((column) => column?.dataIndex !== 'actionDate');
        }
        return columns;
    };

     const deletePendingRequest = async () => {
            setIsLoading(true);
            try {
                const { data } = await DeletePendingDepositRequest(depositdetails?.requestId);
                if (data?.success) {
                    toast.success(data?.message);
                    setDeleteConfirmation(false);
                    // setIsRefresh(true);
                    getAllDeposit();
                }
            } catch (error) {
                toast.error(error?.response?.data?.error?.message || "An error occurred.");
            } finally {
                setIsLoading(false);
            }
        }

    const getAllDeposit = async () => {
        setIsLoading(true);
        try {
            const params = {
                PageNumber: page,
                PageSize: pageSize,
                FilterText: filter,
                UserId: userDetails?.id,
                ...sorter,
            };

            const { data } = await GetAllDepositRequestApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return ({
                            ...item,
                            balance: `$ ${item?.balance}`,
                            amount: `$ ${item?.requestedAmount}`,
                            requestDate: formatDate(item?.requestDate) || '--',
                            actionDate: formatDate(item?.actionDate) || '--',
                            actions: (
                                <div className="flex items-center gap-2">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setDepositdetails(item);
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        <Eye />
                                    </button>

                                    {filter === 'Pending' && <button
                                        type="button"
                                        onClick={() => {
                                            setDepositdetails(item);
                                            setDeleteConfirmation(true);
                                        }}
                                    >
                                        <Delete />
                                    </button>}
                                </div>
                            )
                        })
                    })
                );
                setTotalRecord(data?.totalRecords);
                setIsRefresh(false);
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getAllDeposit();
    }, [page, filter, pageSize, sorter, isRefresh]);

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'requestDate', SortOrder: '' });
        }
    };

    return (
        <div>
            <div className='block sm:flex flex-wrap justify-between items-center gap-5 '>
                <Segmented
                    options={[
                        { label: 'Approved', value: 'Approved' },
                        { label: 'Pending', value: 'Pending' },
                        { label: 'Declined', value: 'Declined' },
                    ]}
                    value={filter}
                    setValue={(value) => {
                        setFilter(value);
                        setPage(1);
                    }}
                    block={isMobile}
                />
            </div>

            <div className='mt-6'>
                <div className="border border-gray-200 rounded-xl">
                    <TableWithSkeleton columns={getFilteredColumns(filter)} data={data} loading={isLoading} onChange={handleTableChange} />
                </div>

                <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
            </div>

            <ModalComponent
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                title='Deposit Information'
                width={1300}
            >
                <div className='p-5'>
                    <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10'>
                        <div>
                            <p className='text-base font-normal'>Wallet Account No.</p>
                            <p className='text-xl primary font-semibold mt-2'>{depositdetails?.walletAccountNo}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Deposit Type</p>
                            <p className='text-xl primary font-semibold mt-2'>{depositdetails?.depositType}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Amount</p>
                            <p className='text-xl primary font-semibold mt-2'>$ {depositdetails?.requestedAmount}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Wallet Balance</p>
                            <p className='text-xl primary font-semibold mt-2'>$ {depositdetails?.balance}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Status</p>
                            <p className='text-xl primary font-semibold mt-2'>{depositdetails?.status}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Request Date</p>
                            <p className='text-xl primary font-semibold mt-2'>{formatDate(depositdetails?.requestDate) || "--"}</p>
                        </div>
                        {depositdetails?.status !== "Pending" ? <div>
                            <p className='text-base font-normal'>Action Date</p>
                            <p className='text-xl primary font-semibold mt-2'>{formatDate(depositdetails?.actionDate) || "--"}</p>
                        </div> : ""}
                        {depositdetails?.status === "Approved" ? <div>
                            <p className='text-base font-normal'>Accepted Amount</p>
                            <p className='text-xl primary font-semibold mt-2'>$ {depositdetails?.acceptedAmount || 0} </p>
                        </div> : ""}
                        {depositdetails?.documentUrl?.length ? (
                            <div>
                                <p className="text-[#1E232CC7] text-lg">Document</p>
                                <div className="flex items-center cursor-pointer" onClick={() => setIsDocumentOpen(true)}>
                                    <p className="primary text-lg font-semibold mt-2 underline mr-2">View Document</p>
                                </div>
                            </div>
                        ) : null}
                        {depositdetails?.status !== "Pending" ? <div className='col-span-full'>
                            <p className='text-base font-normal'>Comment</p>
                            <p className='text-xl primary font-semibold mt-2'>{depositdetails?.comment || '--'}</p>
                        </div> : ""}
                    </div>
                </div>
            </ModalComponent>

            <ModalComponent isOpen={isDocumentOpen} setIsOpen={setIsDocumentOpen} title="View Document" width={1000}>
                <div className='p-5'>
                    <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10'>
                        {depositdetails?.documentUrl?.map((url, index) => (
                            <div key={index}>
                                <div className="border border-gray-300 rounded-lg">
                                    {url?.endsWith('.pdf') ? (
                                        <iframe
                                            src={url}
                                            title={`Deposit Document ${index + 1}`}
                                            className="w-full h-64 rounded-lg cursor-pointer"
                                            onClick={() => url && window.open(url, "_blank")}
                                        />
                                    ) : (
                                        <img
                                            src={url}
                                            alt={`Deposit Document ${index + 1}`}
                                            className="w-full h-auto rounded-lg cursor-pointer"
                                            onClick={() => url && window.open(url, "_blank")}
                                        />
                                    )}
                                </div>

                            </div>
                        ))}
                    </div>
                </div>
            </ModalComponent>
            <ConfirmationModal
                isOpen={deleteConfirmation}
                setIsOpen={setDeleteConfirmation}
                message="Are you sure you want to delete this request?"
                onConfirm={deletePendingRequest}
                isLoading={isLoading}
                loadingLabel="Deleting reqest..."
            />
        </div>
    )
}

export default DepositRequest
